export enum EPunchValidationType {
    Valid,
    InvalidHierarchy,
    NotAllowedByHierarchyDefinition,
    NotAllowedByLockedPeriod,
    NotAllowedForAccount,
    SplitPunchError,
    OverriddenDayGroupPunchSetMaxLengthError,
    NotAllowedOverrideDayGroupForSpecificPS,
    NotAllowedCalcualtionDayByLockedPeriod,
    InvalidEmployee,
    ExecutionError,
    NotAllowedByEmployeePermission,
    AlreadyDeleted,
    InactiveEmployeeSuspensePunch,
    SuspensePunch,
    InvalidIPAddress,
    EmptyPhase,
    FreeAccountLimitSuspensePunch,
    InvalidAssignedJob
}
